/**
 * A render-time error boundary for an exception thrown in render, such as NaN in
 * a BufferGeometry. R3F mounts its scene in a separate reconciler root, which an
 * outer boundary cannot catch, so the same class serves `PreviewErrorBoundary`
 * and `NodeDispatcher`'s per-node catch.
 */
import { Component } from 'react';
import * as logger from '../../logger.js';
export class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        logger.error('[ErrorBoundary] render crashed:', error, info.componentStack ?? '');
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (!this.state.error)
            return;
        const prevKeys = prevProps.resetKeys;
        const keys = this.props.resetKeys;
        if (!keys || keys.length !== prevKeys?.length)
            return;
        const changed = keys.some((key, i) => !Object.is(key, prevKeys[i]));
        if (changed)
            this.reset();
    }
    reset = () => {
        this.setState({ error: null });
        this.props.onReset?.();
    };
    render() {
        const { error } = this.state;
        if (error) {
            return this.props.fallback(error, this.reset);
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map